<template>
  <div class="border border-solid border-steam rounded-lg p-[20px]">
    <div class="flex gap-2 items-center">
      <span class="material-symbols-outlined text-industrial-revolution text-[24px]">receipt</span>
      <p class="text-young-night text-lg">{{ $t('Shipping Fees') }}</p>
    </div>
    <div class="mt-6" v-if="orderData.is_exchange">
      <p class="text-darkgray font-medium text-sm mt-1 leading-tight">{{ $t('This Order is part of an exchange order. Please, Check the price on the exchange order.') }}</p>
    </div>
    <div class="mt-6" v-else-if="(orderData.is_exchange && common.defineOrderType(orderData) !== 'returns') || !orderData.is_exchange">
      <div v-if="orderData.tracking_number && orderData.tracking_number[0] !== '4'">
        <div class="flex items-center justify-between mt-4 text-young-night sm:text-base text-sm" v-for="price in orderData.order_price?.price_breakdown_item || []" :key="price.index">
          <p>{{ price ? price.description === 'Base Fees (M-FLY)' ? $t('Medium Flyer') : price.description === 'Base Fees (S-FLY)' ? $t('Small Flyer') : price.description === 'Base Fees (L-FLY)' ? $t('Large Flyer') : price.description === 'Base Fees (XL-FLY)' ? $t('X-Large Flyer') : $t(price.description) : '' }}</p>
          <p>{{ price ? `EGP ${Number(price.value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '' }}</p>
        </div>
        <div class="flex items-center justify-between mt-4 text-young-night sm:text-base text-sm" v-for="discount in orderData.order_price?.discount_breakdown_item || []" :key="discount.index">
          <p>{{ discount ? discount.description : '' }}</p>
          <p>{{ discount ? '(' + Number(discount.value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) + ')' : '' }}</p>
        </div> 
      </div>
      <vs-divider v-if="!orderData.request_price" color="#DEDEDE"/>
      <div class="flex items-center justify-between mb-3 mt-4 text-young-night sm:text-base text-sm">
        <p>{{ $t('Subtotal') }}</p>
        <p>{{ orderData?.order_price ? `EGP ${Number(orderData?.order_price?.subtotal || 0).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}` : `EGP ${Number(orderData?.request_price?.subtotal || 0).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}` }}</p>
      </div>
      <div class="flex items-center justify-between">
        <p>{{ $t('VAT') }}</p>
        <p>{{ orderData?.order_price ? `EGP ${Number(orderData?.order_price?.vat || 0).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}` : `EGP ${Number(orderData?.request_price?.vat || 0).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}` }}</p>
      </div>
      <div v-if="common.defineOrderType(orderData) === 'delivery-orders' && merchantStatus === 'active'" class="mt-6 flex md:flex-row flex-col w-full md:items-end justify-between md:gap-4 gap-3">
        <shipblu-input class="w-full" autocomplete="nofill" :labelPlaceholder="$t('Promo Code')" name="promo code" @keyup.enter.native="editPromoCode" v-model="orderData.discount_code" />
        <shipblu-button size="large" color="secondary" :disabled="!orderData.discount_code" @click="editPromoCode" :textButton="`${$t('Apply')}`" class="md:w-[100px] w-full"/>
      </div>
      <vs-divider color="#DEDEDE" class="mt-8"/>
      <div class="flex items-center justify-between mt-5 text-young-night sm:text-2xl text-lg sm:font-medium font-normal">
        <p>{{ $t('Total') }}</p>
        <p>{{ orderData?.order_price ? `EGP ${Number(orderData?.order_price?.total || 0).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}` : `EGP ${Number(orderData?.request_price?.total || 0).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2})}` }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'
import i18nData from '../../../i18n/i18nData'
import { sendRequest } from '../../../http/axios/requestHelper'
import common from '../../../assets/utils/common'

export default {
  props: ['orderData', 'merchantStatus'],
  data () {
    return {
      common,
      routerTypesDic: {'delivery-orders': 'returns', 'returns': 'delivery-orders'}
    }
  },
  methods: {
    editPromoCode () {
      sendRequest(true, false, this, `api/v1/${common.defineOrderType(this.orderData)}/${this.$route.query.order}/`, 'patch', {discount_code: this.orderData.discount_code}, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Delivery Order'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
            position: 'top-center'
          })
          this.$emit('loadOrder', 'priceCardLoading')
        },
        (error) => {
          common.notifyResponseError(this, error)
          this.$emit('loadOrder', 'priceCardLoading')
        }
      )
    }
  },
  components: {
    ShipbluCard
  }
}
</script>